import { useTranslation } from 'react-i18next';

import { PLANNED_DELIVERY_WINDOWS_MAX_NAMES_BEFORE_COUNT } from '../../../constants';

import styles from './chips-section.module.scss';

interface ChipsSectionProps {
	serviceAreaCount: number;
	servicePlans: string[];
}

export const ChipsSection = ({ serviceAreaCount, servicePlans }: ChipsSectionProps) => {
	const { t } = useTranslation();
	let servicePlansContent = null;

	if (servicePlans.length) {
		if (servicePlans.length > PLANNED_DELIVERY_WINDOWS_MAX_NAMES_BEFORE_COUNT) {
			servicePlansContent = [
				<span className={styles.chip} key="plans-count">
					{t('PLANNED_DELIVERY_WINDOWS_SLOT_CARD.SERVICE_PLAN_LABEL_plural', { names: servicePlans.length })}
				</span>
			];
		} else {
			servicePlansContent = servicePlans.map((item, index) => (
				<span className={styles.chip} key={index}>
					{item}
				</span>
			));
		}
	}

	const serviceAreasContent =
		serviceAreaCount > 0 ? (
			<span className={styles.chip}>
				{t('PLANNED_DELIVERY_WINDOWS_SLOT_CARD.SERVICE_AREAS_COUNT', { count: serviceAreaCount })}
			</span>
		) : null;

	if (!servicePlansContent && !serviceAreasContent) {
		return null;
	}

	return (
		<div className={styles.sectionBody}>
			{servicePlansContent}
			{serviceAreasContent}
		</div>
	);
};
